class DickiesProductCard extends HTMLElement {
  constructor() {
    super();

    this.radioInputs = this.querySelectorAll('input[type="radio"]');
    this.imageLinks = this.querySelectorAll('.dickies-product-card__image-link');
    this.infoWrappers = this.querySelectorAll('.dickies-product-card__info-wrapper');
    this.quickViewButton = this.querySelector('[data-dickies-quick-view-button]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.radioInputs.forEach((radio) => {
      radio.addEventListener('change', this.handleRadioChange.bind(this));
    });
  }

  handleRadioChange(event) {
    const escapedColorValue = CSS.escape(String(event.target.value));
    const matchingImageLink = this.querySelector(
      `.dickies-product-card__image-link[data-color="${escapedColorValue}"]`
    );
    const matchingInfoWrapper = this.querySelector(
      `.dickies-product-card__info-wrapper[data-color="${escapedColorValue}"]`
    );

    if (matchingImageLink) {
      this.imageLinks.forEach((imageLink) => {
        if (matchingImageLink === imageLink) {
          const linkImages = imageLink.querySelectorAll('img');

          linkImages.forEach((img) => {
            if (img.src && img.srcset) {
              return;
            }

            img.src = img.getAttribute('data-src');
            img.srcset = img.getAttribute('data-srcset');
          });

          imageLink.style.display = 'block';

          if (this.quickViewButton) {
            const productUrl = imageLink.getAttribute('data-product-url') || imageLink.getAttribute('href');
            if (productUrl) {
              this.quickViewButton.setAttribute('data-product-url', productUrl);
            }
          }
        } else {
          imageLink.style.display = 'none';
        }
      });
    }

    if (matchingInfoWrapper) {
      this.infoWrappers.forEach((price) => {
        if (matchingInfoWrapper === price) {
          price.style.display = 'block';
        } else {
          price.style.display = 'none';
        }
      });
    }
  }
}

const initDickiesProductCard = () => {
  customElements.get('dickies-product-card') || customElements.define('dickies-product-card', DickiesProductCard);
};

export default initDickiesProductCard;

initDickiesProductCard();
